/**
 * Helpers for Geoapify city autocomplete results.
 */

/** "City, State, Country" label for a Geoapify feature (or its properties). */
export function formatCityLabel(featureOrProps) {
  const p = featureOrProps?.properties || featureOrProps || {};
  return [p.city || p.county || p.name, p.state, p.country].filter(Boolean).join(", ");
}

/**
 * Remove suggestions that would show the same label twice (Geoapify returns
 * e.g. the city and its administrative area, both "Toronto, Ontario, Canada").
 * Keeps the first occurrence, so the API's ranking is preserved.
 */
export function dedupeCitySuggestions(features) {
  if (!Array.isArray(features)) return [];
  const seen = new Set();
  return features.filter((f) => {
    const label = formatCityLabel(f).toLowerCase();
    if (!label || seen.has(label)) return false;
    seen.add(label);
    return true;
  });
}
